/* eslint-disable no-undef */
$(document).ready(function() {
  if (!document.querySelector('.videos-exercises-and-hints-accordion')) {
    return;
  }
  new Foundation.Accordion($('.videos-exercises-and-hints-accordion'));
});
